import { formatMesAno } from "../../utils/Formatter";

export function get(fetch, filtros) {
  return fetch().post("/indicador", { ...filtros, mesAno: formatMesAno(filtros.mesAno) });
}

export function getDetalhe(fetch, filtros) {
  return fetch().post(`/indicador/detalhe`, { ...filtros, mesAno: formatMesAno(filtros.mesAno) });
}
